export const head = {
    styles: `
<style>
/* BASIC RESET */
html, body, body div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, figure, footer, header, menu, nav, section, time, mark, audio, video, details, summary {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-weight: normal;
    vertical-align: baseline;
    background: transparent;
}

main, article, aside, figure, footer, header, nav, section, details, summary {display: block;}

html {
    box-sizing: border-box;
}

a {margin: 0; padding: 0; font-size: 100%; vertical-align: baseline; background: transparent;}

/* tables still need cellspacing="0" in the markup */
table {border-collapse: collapse; }
th {font-weight: bold; vertical-align: bottom;}
td {font-weight: normal; vertical-align: top;}

hr {display: block; height: 1px; border: 0; border-top: 1px solid #ccc; margin: 1em 0; padding: 0;}

table {font-size: inherit; font: 100%;}

small {font-size: 85%;}

strong {font-weight: bold;}

td, td img {vertical-align: top;}

sub, sup {font-size: 75%; line-height: 0; position: relative;}
sup {top: -0.5em;}
sub {bottom: -0.25em;}

.clearfix:after { content: " "; display: block; clear: both; }

/* REGULAR STYLES */
body {
    font-family:  'Arial Unicode MS', Arial, Helvetica, sans-serif;
    font-size: 14px;
    /* Size FIX */
    margin-bottom: 70px;
}

.template-base {
    display: block;
    max-width: 700px;
    min-height: 100%;
    margin: 0 auto;
    font-size: 12px;
}

.template-base h1,
.template-base h2,
.template-base h3,
.template-base h4,
.template-base h5,
.template-base h6 {
    font-size: 22px;
    margin: 5px 0;
    padding: 5px 0 0 0;
    font-weight: medium;
}

.template-base h2 {
    font-size: 20px;
}

.template-base h3 {
    font-size: 18px;
}

.template-base h4 {
    font-size: 16px;
}

.template-base h5 {
    font-size: 14px;
}

.template-base h6 {
    font-size: 12px;
}

.template-base blockquote {
    border-left: 3px solid #dddddd;
    padding-left: 15px;
}

.template-base p {
    margin: 5px 0;
    padding: 0;
}

.template-base table {
    border-collapse: collapse;
    width: 100%;
    margin: 10px 0;
}

.template-base table tr td,
.template-base table tr th {
    padding: 2px 5px;
    vertical-align: top;
    border: 1px solid #01579B;
    border-left: none;
    border-right: none;
}

.template-base table tr td p,
.template-base table tr th p {
    margin: 0;
    padding: 0;
}

.template-base table tr th {
    font-weight: bold;
    text-align: left;
}

.template-base table tr:first-child td,
.template-base table tr:first-child th {
    border-top: none;
}

.template-base table tr:last-child td,
.template-base table tr:last-child th {
    border-bottom: none;
}

.template-base table tr td,
.template-base table tr th {
    border-left: none;
    border-right: none;
}


.template-base table tr td,
.template-base table tr th {
    border-right: 1px solid #01579B;
}

.template-base table tr td:first-child,
.template-base table tr th:first-child {
    border-left: none;
}

.template-base table tr td:last-child,
.template-base table tr th:last-child {
    border-right: none;
}

.template-base ul {
    padding: 5px 16px;
}

.template-base ul li {
    list-style-type: disc;
}

.template-base ul li ul li {
    list-style-type: circle;
}

.template-base ul li ul li ul li {
    list-style-type: square;
}

.template-base ol {
    padding: 5px 16px;
}

.template-base ol li {
    list-style-type: decimal;
}

.template-base ol li ol li {
    list-style-type: lower-alpha;
}

.template-base ol li ol li ol li {
    list-style-type: lower-alpha;
}

.template-base img {
    max-width: 100%;
    width: 100%;
    height: auto;
}
</style>
</style>
<style media="screen">
#footer {
    display: none;
}
</style>
<style media="print">
/* ********
* Print/PDF section
******** */
@page {
    size: A4 portrait;
    margin: 20px 38px 76px 38px;
    font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;

    @bottom-right {
        content: "[=templateOriginCode] | strana " counter(page) " / " counter(pages);
        border-top: 1px solid #DDDDDD;
        font-size: 10px;
        color: #81ACCE;
        font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;
    }

    @bottom-left {
        content: element(footer);
        border-top:1px solid #DDDDDD;
        font-size: 10px;
    }
}

#footer {
    position: running(footer);
    font-family: 'Arial Unicode MS', Arial, Helvetica, sans-serif;
    color: #888888;
    font-size: 10px;
    line-height: 16px;
}

#footer a {
    color: #81ACCE;
    text-decoration: none;
}
</style>`,
};
